import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const KPIWidget = ({ kpi, onDrillDown }) => {
  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case 'up':
        return 'text-success';
      case 'down':
        return 'text-destructive';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatValue = (value, type) => {
    switch (type) {
      case 'currency':
        return `$${value?.toLocaleString()}`;
      case 'percentage':
        return `${value}%`;
      case 'number':
        return value?.toLocaleString();
      default:
        return value;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-card transition-hover">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${kpi?.iconBg}`}>
            <Icon name={kpi?.icon} size={24} color={kpi?.iconColor} />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">{kpi?.title}</h3>
            <p className="text-2xl font-bold text-foreground">{formatValue(kpi?.value, kpi?.type)}</p>
          </div>
        </div>
        <Button variant="ghost" size="icon" onClick={() => onDrillDown(kpi)}>
          <Icon name="ExternalLink" size={16} />
        </Button>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon 
            name={getTrendIcon(kpi?.trend)} 
            size={16} 
            className={getTrendColor(kpi?.trend)} 
          />
          <span className={`text-sm font-medium ${getTrendColor(kpi?.trend)}`}>
            {kpi?.changeValue}
          </span>
        </div>
      </div>
      {kpi?.sparklineData && (
        <div className="mt-4">
          <div className="h-8 bg-muted rounded flex items-end space-x-1 px-2">
            {kpi?.sparklineData?.map((value, index) => (
              <div
                key={index}
                className="bg-primary rounded-t flex-1"
                style={{ height: `${(value / Math.max(...kpi?.sparklineData)) * 100}%` }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default KPIWidget;